import { useEffect, useState } from "react";
import { Link } from "react-router";
import { ErrorNotice, useAction } from "../components/ui";
import { api, type CandidateApplication } from "../lib/api";

const pad = (n: number) => String(n).padStart(2, "0");
const STATUS: Record<CandidateApplication["status"], string> = {
  active: "",
  placed: "placed",
  rejected: "rejected",
  withdrawn: "withdrew",
};

/** Where this candidate is in every process. */
export function CandidateJobs({ candidateId }: { candidateId: string }) {
  const [apps, setApps] = useState<CandidateApplication[] | null>(null);
  const load = useAction();

  useEffect(() => {
    void load.run(async () => setApps((await api.candidateApplications(candidateId)).applications));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [candidateId]);

  return (
    <section className="section" aria-labelledby="cand-jobs-h">
      <div className="section-head">
        <h2 id="cand-jobs-h" className="label">
          Jobs
        </h2>
        <span className="label figures">{apps ? pad(apps.length) : "…"}</span>
      </div>
      <ErrorNotice error={load.error} />
      <ol className="index">
        {apps?.map((a, i) => (
          <li key={a.id} className={a.status === "rejected" || a.status === "withdrawn" ? "inactive" : undefined}>
            <span className="num" aria-hidden>
              {pad(i + 1)}
            </span>
            <span className="main">
              <span className="primary">
                <Link to={`/applications/${a.id}`}>{a.job.title}</Link>
                <span className="secondary"> · {a.company.name}</span>
              </span>
              <span className="secondary">{a.status === "active" ? `At ${a.stageName}` : a.status === "placed" ? STATUS.placed : `${STATUS[a.status]} at ${a.stageName}`}</span>
            </span>
            <span className="actions">
              {a.status === "placed" && <span className="status">Placed</span>}
            </span>
          </li>
        ))}
        {apps && apps.length === 0 && (
          <li>
            <span className="empty">Not on any jobs yet. Add them from a job's pipeline.</span>
          </li>
        )}
      </ol>
    </section>
  );
}
